import Services from '../../../../services';

class Api {
  // API SERVER
  get(params) {
    return Services.get('hrdu/approval_rencana_proyek/list', { params });
  }

  getHistory(params) {
    return Services.get('hrdu/approval_rencana_proyek/history/list', {
      params,
    });
  }

  getSingle(params) {
    return Services.get('hrdu/approval_rencana_proyek/detail', { params });
  }

  approve(data) {
    return Services.post('hrdu/approval_rencana_proyek/approve', data);
  }
}

export default new Api();
